import React from 'react';
import { Box, Collapse, SxProps } from '@mui/material';
import { LifeGraphFilterContainer } from '../lifegraph-filter';
import { styles } from './lifegraph-explorer-helper';
import { LifeGraphExplorerFilter } from './lifegraph-explorer.types';
import { Dictionary } from '../../../../lib';
import {
    AdvancedFormInputs,
    FilterMode,
} from '../lifegraph-filter/life-graph-filters-helpers';

interface CollapseContainerProps {
    collapse: boolean;
    filter: LifeGraphExplorerFilter | string | undefined;
    data: Dictionary[];
    handleSetFilter: (
        newFilter: LifeGraphExplorerFilter | string | undefined
    ) => void;
    filterMode: FilterMode;
    setFilterMode: React.Dispatch<React.SetStateAction<FilterMode>>;
    defaultQuery: AdvancedFormInputs;
    setDefaultQuery: React.Dispatch<React.SetStateAction<AdvancedFormInputs>>;
    collapseContainerStyles?: SxProps;
    collapseInnerContainerStyles?: SxProps;
}

export const CollapseContainer = ({
    collapse,
    handleSetFilter,
    filter,
    data,
    filterMode,
    setFilterMode,
    defaultQuery,
    setDefaultQuery,
    collapseContainerStyles,
    collapseInnerContainerStyles,
}: CollapseContainerProps): React.JSX.Element => {
    return (
        <Collapse in={collapse} sx={collapseContainerStyles}>
            <Box sx={collapseInnerContainerStyles}>
                <Box sx={styles.box}>
                    <LifeGraphFilterContainer
                        filter={filter}
                        setFilter={handleSetFilter}
                        dictionaries={data}
                        filterMode={filterMode}
                        setFilterMode={setFilterMode}
                        defaultQuery={defaultQuery}
                        setDefaultQuery={setDefaultQuery}
                    />
                </Box>
            </Box>
        </Collapse>
    );
};
